export const CORE = {
    BLOB_META_DATA: `/ai-advisor-storage/getblobmetadata`
}